import React from 'react';
import GDPRModal from './GDPR/GDPRModal';
import AppLink from '../links/AppLink';
import styles from './Top.module.less';
import AccountContext from '../../services/AccountContext';

export default function Top() {
  const { isPremium } = React.useContext(AccountContext);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageWidth}>
        <div className={styles.content}>
          <div className={styles.column}>
            <h3 className={styles.heading}>Educational Tools</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <AppLink
                  href="/resources/"
                  data-cid="11.2172"
                  className={styles.text}
                >
                  Learning Library
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <AppLink
                  href="/worksheets/"
                  data-cid="11.2173"
                  className={styles.text}
                >
                  Worksheets
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <AppLink
                  href="/games/"
                  data-cid="11.2174"
                  className={styles.text}
                >
                  Games
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <AppLink
                  href="/interactive-worksheets-overview/"
                  data-cid=""
                  className={styles.text}
                >
                  Interactive Worksheets
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/worksheet-generator/"
                  data-cid="11.2182"
                  className={styles.text}
                >
                  Worksheet Generator
                </a>
              </li>
              <li className={styles.listItem}>
                <AppLink
                  href="/lesson-plans/"
                  data-cid="11.2181"
                  className={styles.text}
                >
                  Lesson Plans
                </AppLink>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/common-core/"
                  data-cid="11.2183"
                  className={styles.text}
                >
                  Common Core Resources
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/guided-lessons-overview/"
                  data-cid="11.2168"
                  className={styles.text}
                >
                  Guided Lessons
                </a>
              </li>
              <li>
                {isPremium ? (
                  <a
                    href="/progress-tracker/class-proficiency/"
                    data-cid="11.2169"
                    className={styles.text}
                  >
                    Progress Tracker
                  </a>
                ) : (
                  <a href="/progress-tracker-overview/" className={styles.text}>
                    Progress Tracker
                  </a>
                )}
              </li>
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.heading}>Support</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <a
                  href="https://support.education.com/hc/en-us"
                  data-cid="11.2188"
                  className={styles.text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Help center
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/pricing/" className={styles.text}>
                  Pricing
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/school-accounts/"
                  data-cid="11.219"
                  className={styles.text}
                >
                  Education.com For Schools
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/request-quote/"
                  data-cid="11.2186"
                  className={styles.text}
                >
                  Get a Quote
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/gift/" data-cid="11.2203" className={styles.text}>
                  Give Gift
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/gift/redeem/"
                  data-cid="11.2204"
                  className={styles.text}
                >
                  Redeem Gift
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/sitemap/" className={styles.text}>
                  Site Map
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/support/contact/"
                  data-cid="11.2201"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.text}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.heading}>Connect</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <a
                  href="https://blog.education.com"
                  className={styles.text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="http://www.ixl.com/feedback/educationdotcom"
                  className={styles.text}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Tell us what you think
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.column}>
            <h3 className={styles.heading}>About</h3>
            <ul className={styles.list}>
              <li className={styles.listItem}>
                <a href="/about/" data-cid="11.2196" className={styles.text}>
                  Company
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="https://www.ixl.com/company/careers"
                  className={styles.text}
                >
                  Careers
                </a>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/about/press/"
                  data-cid="11.2199"
                  className={styles.text}
                >
                  Press
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/reviews/" data-cid="11.2202" className={styles.text}>
                  Reviews
                </a>
              </li>
              <li className={styles.listItem}>
                <a href="/privacy/" data-cid="11.2192" className={styles.text}>
                  Privacy Policy
                </a>
              </li>
              <li className={styles.listItem}>
                <strong>
                  <a
                    href="/privacy/child-privacy/"
                    data-cid="11.2193"
                    className={styles.text}
                  >
                    COPPA Privacy Policy
                  </a>
                </strong>
              </li>
              <li className={styles.listItem}>
                <a
                  href="/terms-of-use/"
                  data-cid="11.2194"
                  className={styles.text}
                >
                  Terms of Service
                </a>
              </li>
              {/* todo: show only in gdpr required countries*/}
              <li className="in-gdpr-enabled">
                <GDPRModal />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
